import type { ResourceBlock } from '@domain/schemas/contract.schema';

export type BlockEntityKind = 'block' | 'clause';

export const isClauseType = (type?: string): boolean => type === 'clause' || type === 'clause-heading';

export const isClauseBlock = (block: Pick<ResourceBlock, 'type'>): boolean => isClauseType(block.type);

export const getBlockEntityKind = (block: Pick<ResourceBlock, 'type'>): BlockEntityKind =>
  isClauseBlock(block) ? 'clause' : 'block';
